// extracted by mini-css-extract-plugin
export var actionButton = "_od-0";
export var actionMenuContainer = "_od-i";
export var bubble = "_od-2";
export var bubbleActionMenu = "_od-j";
export var bubbleContext = "_od-6";
export var bubbleItems = "_od-7";
export var customer = "_od-3";
export var divider = "_od-8";
export var fileList = "_od-9";
export var hiddenComment = "_od-o";
export var infoAbove = "_od-a";
export var internal = "_od-4";
export var lightActionButton = "_od-1";
export var link = "_od-b";
export var merchant = "_od-5";
export var message = "_od-c";
export var profilePicture = "_od-e";
export var quillToolbarContainer = "_od-f";
export var senderDate = "_od-g";
export var senderDateCustomer = "_od-h";
export var senderName = "_od-d";
export var time = "_od-k";
export var uploadedImage = "_od-l";
export var username = "_od-m";
export var xsmall = "_od-n";